import { logger } from "@/utils/logger";
// 静态资源管理插件

import type { App } from "vue";
import { images, getImageUrl, getAvatarUrl, assetManager, preloadCriticalImages } from "@/assets";

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $images: typeof images;
    $getImageUrl: typeof getImageUrl;
    $getAvatarUrl: typeof getAvatarUrl;
    $assetManager: typeof assetManager;
    $preloadImage: typeof assetManager.preloadImage;
  }
}

/**
 * 静态资源插件
 */
export default {
  install(app: App) {
    // 注册全局属性
    app.config.globalProperties.$images = images;
    app.config.globalProperties.$getImageUrl = getImageUrl;
    app.config.globalProperties.$getAvatarUrl = getAvatarUrl;
    app.config.globalProperties.$assetManager = assetManager;
    app.config.globalProperties.$preloadImage = assetManager.preloadImage.bind(assetManager);

    // 预加载关键资源
    preloadCriticalImages().catch((error) => {
      logger.warn("预加载关键图片资源失败:", error);
    });

    // 提供全局方法
    app.provide("images", images);
    app.provide("getImageUrl", getImageUrl);
    app.provide("getAvatarUrl", getAvatarUrl);
    app.provide("assetManager", assetManager);
  },
};
